import { TokenPersistenceError } from 'auth/tokenStore';
import { ApiError } from 'core/errors/ApiError';

const TEMPORARY_STATUSES = new Set([0, 408, 429, 500, 502, 503, 504]);

export function isRequestAborted(error) {
  if (!error) {
    return false;
  }
  return error.name === 'CanceledError'
    || error.name === 'AbortError'
    || error.code === 'ERR_CANCELED'
    || error.message === 'canceled';
}

export function isTokenPersistenceError(error) {
  return error instanceof TokenPersistenceError || error?.name === 'TokenPersistenceError' || error?.code === 'TOKEN_PERSISTENCE';
}

export function isTemporaryAuthFailure(error) {
  if (!error || isRequestAborted(error) || isTokenPersistenceError(error)) {
    return false;
  }
  if (error instanceof ApiError) {
    if (error.isNetworkError || error.isMalformed) {
      return true;
    }
    return TEMPORARY_STATUSES.has(Number(error.status));
  }
  if (error.isNetworkError || error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
    return true;
  }
  const status = Number(error.status || error.response?.status);
  return TEMPORARY_STATUSES.has(status);
}

export function isConfirmedAuthFailure(error) {
  if (!error || isRequestAborted(error) || isTemporaryAuthFailure(error)) {
    return false;
  }
  if (error instanceof ApiError) {
    return error.isUnauthorized();
  }
  return Number(error.status || error.response?.status) === 401;
}

export function isForbiddenAuthFailure(error) {
  if (error instanceof ApiError) {
    return error.isForbidden();
  }
  return Number(error?.status || error?.response?.status) === 403;
}
